import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

var routes = [

    { name: 'Onboard', path: '/', component: () => import('@/components/screen/Onboard') },
    { name: 'Report.Data', path: '/:id', component: () => import('@/components/screen/ReportData') },
    { name: 'Report.Cards', path: '/:id/cards', component: () => import('@/components/screen/ReportCards') },
    { name: 'Report.Map', path: '/:id/map', component: () => import('@/components/screen/ReportMap') },
    { name: 'Report.Insights', path: '/:id/insights', component: () => import('@/components/screen/ReportInsights') }

]

export default new Router({
	mode: 'history',
	base: process.env.VUE_APP_BASE,
    routes: routes
})